import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadMask from "../../../Utils/LoadMask/LoadMask";

import EmpresaForm from './EmpresaForm';

class Empresa extends Component {
    static propTypes = {
        crear: PropTypes.func.isRequired,
    };
    state ={
        editar: false,
        titulo: 'AGREGAR EMPRESA',
        data:{}
    }
    componentWillMount(){
        this.props.selectEstablecimientos()
        if(this.props.match.params.id){
            this.props.leer(this.props.match.params.id)
            this.setState({
                editar:true,
                titulo: 'EDITAR EMPRESA',
            });
        }
        else{
            this.setState({
                data:{
                    fecha_fundacion: new Date(),
                    cuenta_inicial: 0,
                    cuenta_por: "1",
                    es_principal: false,
                    es_transporte: false,
                }
            })
        }
    }
    onSubmit = (values) =>{
        const {crear, editar} =this.props
        let id = this.props.match.params.id
        values.fecha_fundacion = new Date(values.fecha_fundacion)
        this.state.editar? editar(id,values) : crear(values);
    }

    render() {
        const { loader, establecimientos } = this.props;
        return (
            <div className="Container">
               <div className="row">
                    <div className="mb-4 col-12">
                        <div className="mb-4 card card-small m-t">
                            <div className="card-body">
                                <h3 className="t-primary card-title">{this.state.titulo}</h3>
                                <div className="p-0 px-3 pt-3">
                                    <LoadMask loading={loader} light type={"TailSpin"}>
                                        <EmpresaForm onSubmit={this.onSubmit} 
                                        initialValues={this.state.data}
                                        establecimientos = {establecimientos}
                                        />
                                    </LoadMask>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Empresa;
